__turbopack_context__.v({
  "balanceContainer": "WalletBalanceDisplay-module__bvHhhG__balanceContainer",
  "btcIcon": "WalletBalanceDisplay-module__bvHhhG__btcIcon",
  "btcIconSmall": "WalletBalanceDisplay-module__bvHhhG__btcIconSmall",
  "incomingBalanceContainer": "WalletBalanceDisplay-module__bvHhhG__incomingBalanceContainer",
  "incomingLabel": "WalletBalanceDisplay-module__bvHhhG__incomingLabel",
  "root": "WalletBalanceDisplay-module__bvHhhG__root",
  "skele": "WalletBalanceDisplay-module__bvHhhG__skele",
});
